module.exports = __webpack_public_path__ + "static/banner-image-55800ab7b756420a2278851a2acf34d6.png";